import NewBulkAction from "./NewBulkAction";
export default NewBulkAction;
